import { Button, Tooltip } from "@/components/ui";
import { RxHistoryModal } from "@/features/Patient/MedicalRecords/RxHistory/RxHistoryModal";
import { useGetPatient } from "@/features/Patient/network/usePatient";
import { useConfigCatFeatureFlag } from "@/network/useConfigCatFeatureFlag";
import { ClipboardList } from "lucide-react";
import { useState } from "react";

interface RxHistoryButtonProps {
  patientId: string;
}

export const RxHistoryButton = ({ patientId }: RxHistoryButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { data: isMedicationHistoryEnabled } = useConfigCatFeatureFlag(
    "emr-surescripts-medication-history",
  );
  const { data: patient } = useGetPatient(patientId);

  if (!isMedicationHistoryEnabled) return null;

  const hasSurescriptsConsent = patient?.hasSurescriptsConsent ?? false;

  return (
    <>
      <Tooltip
        tooltipContentText={
          hasSurescriptsConsent
            ? "Medication History"
            : "Medication history requires Surescripts consent"
        }
        side="bottom"
      >
        <Button
          variant="icon"
          className="m-0 p-0"
          onClick={() => setIsOpen(true)}
          aria-label={
            hasSurescriptsConsent
              ? "View RX history"
              : "Medication history requires Surescripts consent"
          }
          data-testid="rx-history-button"
          disabled={!hasSurescriptsConsent}
        >
          <ClipboardList
            className={`${hasSurescriptsConsent ? "stroke-link" : ""} h-4 w-4`}
          />
        </Button>
      </Tooltip>
      <RxHistoryModal
        open={isOpen}
        onOpenChange={setIsOpen}
        patientId={patientId}
      />
    </>
  );
};
